import { Component, Input } from '@angular/core';
import { FilesService } from 'src/app/shared/services/files.service';
import { ElementComponent } from '../element-wyswyg/element-wyswyg.component';

@Component({
  selector: 'image-wyswyg',
  templateUrl: './image-wyswyg.component.html',
  styleUrls: ['./image-wyswyg.component.css'],
})
export class ImageWyswygComponent extends ElementComponent {
  @Input()
  public override data: any = {}
  // https://stackoverflow.com/questions/63539847/is-there-a-way-to-bind-to-an-array-of-components-in-angular-and-render-those-in

  private filesService: FilesService;

  public errorMessage: string = '';

  constructor() {
    super()
    this.filesService = new FilesService();
  }

  onFileSelected(event: any): void {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.errorMessage = '';

      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        this.errorMessage = 'El tamaño máximo permitido es 5MB.';
        return;
      }

      this.data.uploadData = {};
      this.data.src = URL.createObjectURL(file);

      this.filesService.getBase64Image(file).then((base64File) => {
        this.data.uploadData = {
          base64File,
          fileName: file.name,
          contentType: file.type
        };
      });
    }
  }

}
